'use client'

import React, { useEffect } from "react";
import classNames from "classnames";
import { InventoryExpanderProps, InventoryRowProps } from "../types";
import { ChevronDownIcon } from "@/migrated-widgets/table-map/components/icons/ChevronDownIcon";

export const InventoryRow: React.FC<InventoryRowProps> = ({ children, className, isHighlighted = false, useCursorPointer = false, onClick, onUnmount }) => {
  useEffect(() => { return () => onUnmount?.() }, []);

  return (
    <div className={classNames(
      "flex justify-between items-center w-full px-10 py-3 border-b border-b-table-map-lightGray gap-2 hover:backdrop-brightness-95",
      className,
      { 'bg-table-map-teal': isHighlighted },
      { 'cursor-pointer': useCursorPointer },
    )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export const InventoryCell: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, className, onClick }) => {
  return (
    <div className={classNames("flex items-center gap-1 text-sm tracking-[-0.15] text-left text-table-map-black", className)} onClick={onClick}>
      {children}
    </div>
  );
};

export const InventoryExpander: React.FC<InventoryExpanderProps> = ({ isExpanded, onClick }) => {
  return (
    <ChevronDownIcon className={classNames('w-4', { '-rotate-90': !isExpanded })} onClick={onClick} />
  );
};
